import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import { lightGreen } from "@material-ui/core/colors";

const ColorButton = withStyles((theme: Theme) => ({
  root: {
    color: "white",
    width: "90%",
    backgroundColor: lightGreen[500],
    "&:hover": {
      backgroundColor: lightGreen[600],
    },
  },
}))(Button);

export { ColorButton };
